<template>
  <div class="mailbox-verification-layout">
    <div class="mailbox-verification-layout__header">
      <div>      
        <a :href="serverSideAppUrl" >
          <img v-bind="logo" :width="logoSize" :height="logoSize">
        </a>
        <h4 @click="goToMailbox()">Setup for {{ name }}</h4>
      </div>
      <div>
        <dd-button v-if="showStartOverOption" type="flat" @click="goToVerificationSetup()">
          Start Over
        </dd-button>
        <dd-button v-if="showCancelOption" type="text" @click="goToMailbox()">
          I'll do this later
        </dd-button>
      </div>
    </div>
    <main-container size="smallish" class="mailbox-verification-layout">
      <div class="mailbox-verification-layout__body-wrapper">
        <!-- MAIN -->
        <main class="mailbox-verification-layout__main">
          <slot />
        </main>
      </div>
    </main-container>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import config from '@/config'
import MainContainer from '@/layouts/main-container.vue'
import DefaultLayout from '@/layouts/default-layout.vue'
import * as routerNames from '@/services/router/router.names'

/* Mixins */

/* Components */
import logoSrc from '@/assets/img/logos/logo-donedone.svg'

/* Helpers */

import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'MailboxVerificationLayout',

  components: {
    MainContainer,
    DefaultLayout,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    showStartOverOption: {
      type: Boolean,
      default: false,
    },
    showCancelOption: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      logo: {
        src: logoSrc,
        alt: 'Logo DoneDone',
      },
      routerNames,
      serverSideAppUrl: config.serverSideAppUrl,
    }
  },

  computed: {
    logoSize(): number {
      return this.$screen.isMobile(this.$mq) ? 28 : 32
    },
    notFirstScreen(): boolean {
      return this.$route.name !== routerNames.MAILBOX_VERIFICATION_INTRO
    },
  },

  methods: {
    goToMailbox() {
      RouteAssistant.goToMailbox(
        this.$router,
        this.$route.params.accountId,
        this.$route.params.id,
      )
    },
    goToVerificationSetup() {
      RouteAssistant.goToMailboxVerificationIntroRoute(
        this.$router,
        this.$route.params.accountId,
        this.$route.params.id,
      )
    },
  },
})
</script>

<style lang="scss">
.mailbox-verification-layout {
  padding-top: $navbar-mobile-height;

  @include media-breakpoint-up(md) {
    padding-top: $navbar-desktop-height;
  }

  &__header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1050;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: $navbar-mobile-height;
    padding: 0 15px;
    background-color: var(--color-general-white);
    border-bottom: $border--solid-light;

    @media (min-width: $--sm) {
      height: $navbar-desktop-height;
      line-height: 62px;
    }

    > div {
      display: flex;
      align-items: center;

      > .ddi {
        cursor: pointer;
        font-size: 18px;
        margin-right: 8px;
        color: var(--color-text-third);
      }

      h4 {
        cursor: pointer;
        margin-bottom: 0;
        margin-left: 18px;
        max-width: 400px;
        @include single-line-ellipsis;
      }
    }

    > div:first-child {
      flex: 1;
      min-width: 0;
      overflow: hidden;
    }

    > div:last-child {
      flex-shrink: 0;
      margin-left: 8px;
    }
  }

  &__body-wrapper {
    display: flex;
    flex-direction: row;
  }

  &__sidebar {
    flex: 0 0 224px;
    margin-right: 36px;
  }

  &__main {
    flex-grow: 1;

    h2 {
      margin: 0;
    }

    .el-radio {
      &__label {
        @include lettering--p;
      }

      .el-radio__input.is-checked + .el-radio__label {
        color: var(--color-text-secondary);
      }
    }

    .el-radio + .el-radio {
      margin-left: 0 !important;
    }

    .el-card {
      overflow: visible;
      .el-card__body {
        padding: 24px;

        @include media-breakpoint-down(sm) {
          padding: 16px;
        }

        .dd-divider {
          margin-top: 24px;
          margin-bottom: 24px;
        }
      }
    }
  }
}
</style>
